module.exports = __webpack_public_path__ + "img/wsitl_old.deadf331.svg";